import React from 'react';
import PropTypes from 'prop-types';
import { pure } from '@dbk/ui-react-utils';
import { FormattedNumber } from '@dbk-legacy/format';
import Text from '../../text';
import DbkText, { H2} from '@dbk/ui-text';
import createChangeIndicatedComponent from '../create-change-indicated-component';
import formatCurrencyWithDecimalSplit from './format-currency-with-decimal-split';
import { NO_DATA } from '../../../../constants';
import pickFromStyle from '../../../../utils/pick-from-style';
import { getSign } from '../utils';
import { injectIntl } from 'react-intl';
import styles from '../create-change-indicated-component/create-change-indicated-component.styles'
import { StyleSheet } from 'react-native';

function Currency(props, context) {
  const { value, showDecimal, currency, currencyDisplay, withPlusSign, testID, signBeforeNumber,intl, colorStyle } = props;
  const renderProps = props && props.renderProps;
  const style = renderProps && renderProps.style;
  const curPer = props && props.curPer;

  if (typeof value !== 'number') {
    return (
      <div aria-label={props.intl.messages['app.common.nullValue']}>
        <Text {...renderProps}>{NO_DATA}</Text>
      </div>
      )
  }

  const localeProps = Object.assign({}, props, { style: 'currency' });
  // delete localeProps.minimumFractionDigits;
  // delete localeProps.maximumFractionDigits;

  const absValue = Math.abs(value);
  const formatted = formatCurrencyWithDecimalSplit(
    // context.intl.locale,
    intl.locale,
    absValue,
    localeProps
  );
  if (!showDecimal) {
    formatted.decimal = undefined;
  }
  const size = (renderProps && renderProps.size) || Text.defaultProps.size;
  let internalStyle = style && pickFromStyle(style, 'color');

  const sign = getSign(value, withPlusSign);
  if(colorStyle && sign !== '-'){
      internalStyle = colorStyle && pickFromStyle(colorStyle, 'color');
  }
  let formatedNumber = formatted.number;

  if (currency && currencyDisplay === 'code') {
    formatedNumber = formatted.number.replace(currency, '');
  }

  return (
    <Text testID={testID} {...renderProps}>
      {signBeforeNumber &&  currency && <DbkText style={[internalStyle, StyleSheet.flatten(props.currencyStyle)]}>{`${currency} `}</DbkText>}
      <Text size={size} style={internalStyle}>
        {sign === '-' ? <span style={StyleSheet.flatten(styles.negativeStyling)} aria-label={props.intl.messages['app.common.minusSign']+" "+`${formatedNumber}`.trim()}>{`${sign}${formatedNumber}`.trim()}</span> : `${sign}${formatedNumber}`.trim()}
      </Text>
      {formatted.decimal && (
        <Text size={size} style={[internalStyle, props.decimalStyle]}>
          {formatted.decimal}
        </Text>
      )}
      {!signBeforeNumber && currency && <DbkText tertiary style={[internalStyle, props.currencyStyle]} className="currency">{` ${currency}`}</DbkText>}
      {curPer && curPer}
    </Text>
  );
}

Currency.defaultProps = {
  onlyNegativeStyling: true,
  withPlusSign: false,
  currencyDisplay: 'code',
  showDecimal: true,
  currencyStyle: {},
  decimalStyle: {},
  signBeforeNumber: true,
  testID:null,
  colorStyle : null,
};

Currency.propTypes = {
  ...Text.propTypes,
  ...FormattedNumber.propTypes,
  value: PropTypes.any,
  currencyStyle: PropTypes.object,
  decimalStyle: PropTypes.object,
  onlyNegativeStyling: PropTypes.bool,
  withPlusSign: PropTypes.bool,
  signBeforeNumber: PropTypes.bool,
  currencyDisplay: PropTypes.oneOf(['code', 'symbol']),
  colorStyle:PropTypes.object,
};

Currency.contextTypes = {
  intl: PropTypes.object,
};

//export default pure(Currency);
export default pure(injectIntl(Currency));
export const ChangeIndicatedCurrency = createChangeIndicatedComponent(injectIntl(Currency));
